import React, { useState, useEffect } from "react";
import CreatePage from "../../controls/CreatePage";
import PageSection from "../../controls/PageSection";
import Input from "../../controls/Input";
import Select from "../../controls/Select";
import Colorpickerwithsearchbar from "../../controls/Colorpickerwithsearchbar";
import { useNavigate } from "react-router-dom";
import { fetchCategory } from "../../../api/CategoryApi";
import { fetchSubCategory } from "../../../api/subCategoryApi";
import { fetchProductGroup } from "../../../api/ProductgroupApi";
import { fetchOmniSettings, handleAddOmniSettings } from "../../../api/OnlineStoreApi";
import Autocompletesearch from "../../controls/Autocompletesearch";
import TextArea from "../../controls/TextArea";
import MarginDrawer from "./MarginDrawer";
import CustomSwitch from "../../controls/CustomSwitch";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../../controls/Loading";
import BlockDrawer from "./BlockDrawer"; // Import the BlockDrawer component

const NewHomeSection = () => {
  const location = useLocation();
  const editData = location.state?.row || {};

  // Initialize all states with values from editData if available
  const [title, setTitle] = useState(editData?.Title || "");
  const [subTitle, setSubTitle] = useState(editData?.SubTitle || "");
  const [type, setType] = useState(editData?.Type || "");
  const [columns, setColumns] = useState(editData?.SectionColumns || "1");
  const [rows, setRows] = useState(editData?.SectionRows || "1");
  const [showProductBy, setShowProductBy] = useState(editData?.ShowProductBy || "");
  const [categoryName, setCategoryName] = useState(editData?.CategoryName || "");
  const [categoryId, setCategoryId] = useState(editData?.CategoryID || "");
  const [subCategoryName, setSubCategoryName] = useState(editData?.SubCategoryName || "");
  const [subCategoryId, setSubCategoryId] = useState(editData?.SubCategoryID || "");
  const [productGroupName, setProductGroupName] = useState(editData?.ProductGroupName || "");
  const [productGropupId, setProductGroupId] = useState(editData?.ProductGroupID || "");
  const [displayStyle, setDisplayStyle] = useState(editData?.DisplayStyle || "");
  const [count, setCount] = useState(editData?.Count || 0);
  const [displayDevice, setDisplayDevice] = useState(editData?.DisplayDevice || "");
  const [sequence, setSequence] = useState(editData?.Sequence || "");
  const [content, setContent] = useState(editData?.Content || "");
  const [margin, setMargin] = useState(editData?.SectionMargin || {
    Top: "",
    Bottom: "",
    Left: "",
    Right: ""
  });
  const [padding, setPadding] = useState(editData?.SectionPadding || {
    Top: "",
    Bottom: "",
    Left: "",
    Right: ""
  });
  const [hideSectionTitle, setHideSectionTitle] = useState(editData?.HideSectionTitle || false);
  const [sectionTitleAlignment, setSectionTitleAlignment] = useState(editData?.SectionTitleAlignment || "");
  const [sectionTitleFontSize, setSectionTitleFontSize] = useState(editData?.SectionTitleFontSize || "");
  const [sectionTitleFontColor, setSectionTitleFontColor] = useState(editData?.SectionTitleFontColor || "");
  const [sectionTitleMargin, setSectionTitleMargin] = useState(editData?.SectionTitleMargin || {
    Top: "",
    Bottom: "",
    Left: "",
    Right: ""
  });
  const [sectionTitlePadding, setSectionTitlePadding] = useState(editData?.SectionTitlePadding || {
    Top: "",
    Bottom: "",
    Left: "",
    Right: ""
  });
  const [sectionTitleCssName, setSectionTitleCssName] = useState(editData?.SectionCSSName || "");
  const [sectionBackgroundColor, setSectionBackgroundColor] = useState(editData?.SectionBackgroundColor || "");
  const [sectionTitleColor, setSectionTitleColor] = useState(editData?.SectionTitleColor || "");
  const [sectionTitleUnderLineColor, setSectionTitleUnderlineColor] = useState(editData?.SectionTitleUnderlineColor || "");
  const [omtTag, setOmniTag] = useState(editData?.SectionOmniTag || "");

  // Block related states
  const [blockItems, setBlockItems] = useState(editData?.SectionBlocks || []);
  const [currentBlockIndex, setCurrentBlockIndex] = useState(null);
  const [showBlockDrawer, setShowBlockDrawer] = useState(false);

  const [showDrawer, setShowDrawer] = useState(false);
  const [drawerType, setDrawerType] = useState("");
  const [drawerTitle, setDrawerTitle] = useState("");

  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [productGroupData, setProductGroupData] = useState([]);
  const [homeSectionData, setHomeSectionData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Error states
  const [categoryError, setCategoryError] = useState("");
  const [subCategoryError, setSubCategoryError] = useState("");
  const [productGroupError, setProductGroupError] = useState("");
  const [titleError, setTitleError] = useState("");
  const [typeError, setTypeError] = useState("");
  const [countError, setCountError] = useState("");
  const [contentError, setContentError] = useState("");
  const [showProductByError, setShowProductByError] = useState("");

  const navigate = useNavigate();

  // Initialize block items when columns or rows change
  useEffect(() => {
    if (type === "blocks") {
      const totalBlocks = (parseInt(columns) || 1) * (parseInt(rows) || 1);

      // If we have existing blocks, use them (pad with empty blocks if needed)
      if (blockItems.length > 0) {
        const newBlocks = [...blockItems];
        while (newBlocks.length < totalBlocks) {
          newBlocks.push(createEmptyBlock());
        }
        setBlockItems(newBlocks.slice(0, totalBlocks));
      } else {
        // Create new empty blocks
        const newBlocks = Array(totalBlocks).fill().map(() => createEmptyBlock());
        setBlockItems(newBlocks);
      }
    }
  }, [columns, rows, type]);

  const createEmptyBlock = () => ({
    BlockType: "image",
    BlockImage: null,
    BlockText: "",
    BlockTextFontSize: "",
    BlockTextAlignment: "left",
    BlockVideoURL: "",
    BlockImageText: "",
    BlockLinkType: "",
    BlockCategoryID: "",
    BlockSubCategoryID: "",
    BlockProductGroupID: "",
    BlockPageID: "",
    BlockOmniTag: "",
    Class: `col-md-${12 / (parseInt(columns) || 1)}`
  });

  const fetchCategoriesData = async () => {
   

       try {
                const response =  await fetchCategory();
    
                if (response?.code === "0") {
                  const filterData = response.productCategories.filter(
                    (category) => category.IsDeleted === false && category.ParentID === ""
                  );
                  setCategoryData(filterData);
            
                } else {
                    const errorMessage = response?.data?.message || "Failed to fetch category";
                    console.error("Failed to fetch category:", errorMessage, response);
                    toast.error(errorMessage);
                }
            } catch (error) {
                console.error("Runtime error while fetching category:", error);
                toast.error(
                    error.response?.data?.message ||
                    error.message ||
                    "An unexpected error occurred"
                );
            }
  };

  

  const fetchSubCategoriesData = async () => {
     try {
                const response =  await fetchSubCategory();
    
                if (response?.code === "0") {
                  const filterData = response.productSubCategories.filter(
                    (subCategory) =>
                      subCategory?.IsDeleted === false &&
                      subCategory?.ParentID === categoryId
                  );
                  setSubCategoryData(filterData);
                } else {
                    const errorMessage = response?.data?.message || "Failed to fetch sub category";
                    console.error("Failed to fetch sub category:", errorMessage, response);
                    toast.error(errorMessage);
                }
            } catch (error) {
                console.error("Runtime error while fetching sub category:", error);
                toast.error(
                    error.response?.data?.message ||
                    error.message ||
                    "An unexpected error occurred"
                );
            }
  };

  const fetchProductGroupData = async () => {

            try {
                const response =  await fetchProductGroup();
    
                if (response?.code === "0") {
                  const filterData = response.ProductGroups.filter(
                    (product) => product.IsDeleted === false
                  );
                  setProductGroupData(filterData);
            
                  // If editData has productGroupId, find and set the product group name
                  if (editData?.ProductGroupID) {
                    const productGroup = filterData.find(pg => pg.key === editData.ProductGroupID);
                    if (productGroup) {
                      setProductGroupName(productGroup.Name);
                      setProductGroupId(productGroup.key);
                    }
                  }
                } else {
                    const errorMessage = response?.data?.message || "Failed to fetch product group";
                    console.error("Failed to fetch product group:", errorMessage, response);
                    toast.error(errorMessage);
                }
            } catch (error) {
                console.error("Runtime error while fetching product group:", error);
                toast.error(
                    error.response?.data?.message ||
                    error.message ||
                    "An unexpected error occurred"
                );
            }
  };

  const fetchHomeSectionData = async () => {
    try {
      setLoading(true);
      const response = await fetchOmniSettings();
      if (response.settings) {
        setHomeSectionData(response.settings);

        if (editData?.Name) {
          const sectionIndex = response.settings.HomeSections?.findIndex(
            section => section.Name === editData?.Name
          );
          setSequence(sectionIndex !== -1 ? sectionIndex + 1 : response.settings.HomeSections?.length + 1 || 1);
        } else {
          setSequence(response.settings.HomeSections ? response.settings.HomeSections.length + 1 : 1);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error("Failed to fetch HomeSections");
    }
  };

  useEffect(() => {
    fetchCategoriesData();
    fetchProductGroupData();
    fetchHomeSectionData();
  }, []);

  useEffect(() => {
    fetchSubCategoriesData();
  }, [categoryId]);

  const openBlockDrawer = (index) => {
    setCurrentBlockIndex(index);
    setShowBlockDrawer(true);
  };

  const handleBlockSave = (blockData) => {
    const updatedBlocks = [...blockItems];
    updatedBlocks[currentBlockIndex] = {
      ...blockData,
      Class: `col-md-${12 / (parseInt(columns) || 1)}`
    };
    setBlockItems(updatedBlocks);
    setShowBlockDrawer(false);
  };

  const handleSaveClick = async () => {
    // Reset all errors
    setCategoryError("");
    setSubCategoryError("");
    setProductGroupError("");
    setTitleError("");
    setTypeError("");
    setCountError("");
    setContentError("");
    setShowProductByError("");

    let hasError = false;

    if (!title) {
      setTitleError("Please enter title");
      hasError = true;
    }

    if (!type) {
      setTypeError("Please select type");
      hasError = true;
    }

    if (type === "content" && !content) {
      setContentError("Please enter content");
      hasError = true;
    }

    // if (type === "blocks" && blockItems.some(block =>
    //   block.BlockType === "text" && !block.BlockText ||
    //   block.BlockType === "image" && !block.BlockImage ||
    //   block.BlockType === "video" && !block.BlockVideoURL
    // )) {
    //   toast.error("Please fill all required fields in blocks");
    //   hasError = true;
    // }

    if (hasError) {
      return;
    }

    // Build the payload
    const newSection = {
      Name: editData?.Name || `section_${Date.now()}`,
      Title: title,
      SubTitle: subTitle,
      Type: type,
      CSS: sectionTitleCssName,
      ShowProductBy: showProductBy,
      SubCategoryID: subCategoryId,
      ProductGroupID: productGropupId,
      CategoryID: categoryId,
      Count: count,
      Content: content,
      Sequence: sequence,
      DisplayDevice: displayDevice,
      DisplayStyle: displayStyle,
      SectionBackgroundColor: sectionBackgroundColor,
      HideSectionTitle: hideSectionTitle,
      SectionTitleAlignment: sectionTitleAlignment,
      SectionTitleFontSize: sectionTitleFontSize,
      SectionTitleColor: sectionTitleColor,
      SectionTitleUnderlineColor: sectionTitleUnderLineColor,
      SectionMargin: margin,
      SectionPadding: padding,
      SectionTitleMargin: sectionTitleMargin,
      SectionTitlePadding: sectionTitlePadding,
      SectionColumns: columns,
      SectionRows: rows,
      SectionCSSName: sectionTitleCssName,
      SectionOmniTag: omtTag,
      SectionBlocks: type === "blocks" ? blockItems : []
    };

    // Rest of the save logic remains the same...
    const updatedSectionData = { ...homeSectionData };

    if (!updatedSectionData.HomeSections) {
      updatedSectionData.HomeSections = [];
    }

    if (sequence) {
      const seqNumber = parseInt(sequence) - 1;

      if (editData?.Name && (seqNumber === updatedSectionData.HomeSections.findIndex(section => section.Name === editData?.Name))) {
        updatedSectionData.HomeSections[seqNumber] = newSection;
      } else {
        if (editData?.Name) {
          updatedSectionData.HomeSections = updatedSectionData.HomeSections.filter(section => section.Name !== editData?.Name);
        }

        updatedSectionData.HomeSections.splice(seqNumber, 0, newSection);
        updatedSectionData.HomeSections = updatedSectionData.HomeSections.filter(section => section !== undefined);
      }
    } else {
      if (editData?.Name) {
        const index = updatedSectionData.HomeSections.findIndex(section => section.Name === editData?.Name);
        if (index !== -1) {
          updatedSectionData.HomeSections[index] = newSection;
        } else {
          updatedSectionData.HomeSections.push(newSection);
        }
      } else {
        updatedSectionData.HomeSections.push(newSection);
      }
    }

    setLoading(true);
    try {
      const response = await handleAddOmniSettings(updatedSectionData);

      if (response?.code === "0") {
        toast.success(
          editData?.Name ? "Home section updated successfully" : "Home section added successfully"
        );
        navigate(-1);
      } else {
        const errorMessage = response?.data?.message || "Failed to save home section";
        console.error("Failed to save home section:", errorMessage, response);
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Runtime error while saving home section:", error);
      toast.error(
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred"
      );
    } finally {
      setLoading(false);
    }
  };

  
  const openMarginDrawer = (type) => {
    setDrawerType(type);
    setDrawerTitle(type === "section margin" ? "Set Margin" : 
                   type === "section title margin" ? "Set Title Margin" :
                   type === "section title padding" ? "Set Title Padding" :
                   "Set Padding");
    setShowDrawer(true);
  };

  const handleDrawerSave = (values) => {
    if (drawerType === "section margin") {
      setMargin(values);
    } else if (drawerType === "section title margin") {
      setSectionTitleMargin(values);
    } else if (drawerType === "section title padding") {
      setSectionTitlePadding(values);
    } else if (drawerType === "section padding") {
      setPadding(values);
    }
    setShowDrawer(false);
  };

  const formatValueForDisplay = (value) => {
    if (!value) return "";
    return `Top:${value.Top || "0"}px, Bottom:${value.Bottom || "0"}px, Left:${value.Left || "0"}px, Right:${value.Right || "0"}px`;
  };

  return (
    <CreatePage
      title={editData?.Title ? "Edit Home Section" : "New Home Section"}
      handleCancel={() => navigate(-1)}
      handleSave={handleSaveClick}
    >
      {loading ? <Loading /> :
        <div className="grid gap-4">
          <PageSection title="General Details">
            <div className="grid lg:grid-cols-4 sm:grid-cols-2 gap-5 mt-5">
              <Input
                isMandatory={true}
                label="Title"
                type="text"
                placeholder="Enter your Title Name"
                value={title}
                onChange={(e) => { setTitle(e.target.value); setTitleError(""); }}
                errorMessage={titleError}
              />
              <Input
                label="Sub Title"
                type="text"
                placeholder="Enter your Sub Title Name"
                value={subTitle}
                onChange={(e) => setSubTitle(e.target.value)}
                errorMessage=""
              />

              <Select
                isMandatory={true}
                label="What would you like to display"
                placeholder="Please Select"
                options={[
                  { label: "Products", value: "products" },
                  { label: "Menu", value: "menu" },
                  { label: "Content", value: "content" },
                  { label: "Blocks", value: "blocks" }
                ]}
                value={type}
                onChange={(e) => { setType(e.target.value); setTypeError(""); }}
                errorMessage={typeError}
              />

              {type === "blocks" && (
                <><Select
                  label="Columns"
                  placeholder="Please Select"
                  options={[
                    { label: "1", value: "1" },
                    { label: "2", value: "2" },
                    { label: "3", value: "3" },
                    { label: "4", value: "4" },
                    { label: "6", value: "6" },
                    { label: "12", value: "12" }
                  ]}
                  value={columns}
                  onChange={(e) => setColumns(e.target.value)}
                />
                  <Select
                    label="Rows"
                    placeholder="Please Select"
                    options={[
                      { label: "1", value: "1" },
                      { label: "2", value: "2" },
                      { label: "3", value: "3" },
                      { label: "4", value: "4" },
                      { label: "5", value: "5" },
                      { label: "7", value: "7" },
                      { label: "8", value: "8" },
                      { label: "9", value: "9" },
                      { label: "10", value: "10" }
                    ]}
                    value={rows}
                    onChange={(e) => setRows(e.target.value)}
                  />
                </>
              )}

              {type === "products" && (
                <>
                  <Select
                    label="Display products by"
                    placeholder="Please Select"
                    options={[
                      { label: "Category", value: "category" },
                      { label: "SubCategory", value: "subCategory" },
                      { label: "Product Group", value: "productGroup" },
                      { label: "All Products", value: "allProducts" }
                    ]}
                    value={showProductBy}
                    onChange={(e) => setShowProductBy(e.target.value)}
                    errorMessage={showProductByError}
                  />

                  {(showProductBy === "category" || showProductBy === "subCategory") && (
                    <Autocompletesearch
                      value={categoryName}
                      label="Category"
                      data={categoryData}
                      filterKey={["Name"]}
                      defaultDataCount={10}
                      onChange={(value) => {
                        setCategoryName("");
                        setCategoryId("");
                        setCategoryError("");
                      }}
                      onSelect={(item) => {
                        setCategoryName(item.Name);
                        setCategoryId(item.key);
                        setCategoryError("");
                        setOmniTag(item?.OMNITag || "");
                      }}
                      placeholder="Search Category"
                      renderSuggestion={(item) => (
                        <div>
                          <p className="">{item.Name}</p>
                        </div>
                      )}
                      errormessage={categoryError}
                    />
                  )}

                  {showProductBy === "subCategory" && (
                    <Autocompletesearch
                      value={subCategoryName}
                      label="Sub category to be displayed"
                      data={subCategoryData}
                      filterKey={["Name"]}
                      defaultDataCount={10}
                      onChange={(value) => {
                        setSubCategoryName("");
                        setSubCategoryId("");
                        setSubCategoryError("");
                      }}
                      onSelect={(item) => {
                        setSubCategoryName(item.Name);
                        setSubCategoryId(item.key);
                        setSubCategoryError("");
                        setOmniTag(item?.OMNITag || "");
                      }}
                      placeholder="Search sub category"
                      renderSuggestion={(item) => (
                        <div>
                          <p className="">{item.Name}</p>
                        </div>
                      )}
                      errormessage={subCategoryError}
                    />
                  )}

                  {showProductBy === "productGroup" && (
                    <Autocompletesearch
                      value={productGroupName}
                      label="Product group to be displayed"
                      data={productGroupData}
                      filterKey={["Name"]}
                      defaultDataCount={10}
                      onChange={(value) => {
                        setProductGroupName("");
                        setProductGroupId("");
                        setProductGroupError("");
                      }}
                      onSelect={(item) => {
                        setProductGroupName(item.Name);
                        setProductGroupId(item.key);
                        setProductGroupError("");
                        setOmniTag(item?.OMNITag || "");
                      }}
                      placeholder="Search product group"
                      renderSuggestion={(item) => (
                        <div>
                          <p className="">{item.Name}</p>
                        </div>
                      )}
                      errormessage={productGroupError}
                    />
                  )}

                  <Select
                    label="Style"
                    placeholder="Select Style"
                    options={[
                      { label: "List (Mobile) / Thumbnail (Desktop)", value: "listthumbnail" },
                      { label: "List", value: "list" },
                      { label: "Thumbnail", value: "thumbnail" },
                      { label: "Thumbnail Scroll", value: "thumbnailscroll" }
                    ]}
                    value={displayStyle}
                    onChange={(e) => setDisplayStyle(e.target.value)}
                  />

                  <Input
                    label="No of products to display"
                    type="number"
                    placeholder="Enter no of products to display"
                    value={count}
                    onChange={(e) => { setCount(e.target.value); setCountError(""); }}
                    errorMessage={countError}
                  />
                </>
              )}

              <Select
                label="Devices on which to be displayed"
                placeholder="Desktop/Mobile"
                options={[
                  { label: "Desktop / Mobile", value: "both" },
                  { label: "Desktop", value: "Desktop" },
                  { label: "Mobile", value: "mobile" }
                ]}
                value={displayDevice}
                onChange={(e) => setDisplayDevice(e.target.value)}
              />

              <Select
                id="Sequence"
                label="Sequence"
                placeholder="Select Sequence"
                options={
                  [...Array((homeSectionData.HomeSections?.length || 0) + (editData?.Name ? 0 : 1)).keys()].map(i => ({
                    value: i + 1,
                    label: `${i + 1}`,
                  }))
                }
                value={sequence}
                onChange={(e) => setSequence(e.target.value)}
              />
            </div>

            {type === "content" && (
              <div className="grid grid-cols-1 gap-5 mt-5">
                <TextArea
                  label="HTML content"
                  value={content}
                  onChange={(e) => { setContent(e.target.value); setContentError(""); }}
                  h="100px"
                  placeholder="Enter html content"
                  errorMessage={contentError}
                />
              </div>
            )}
       {type === "blocks" && (
  <div className="flex flex-wrap gap-5 mt-5">
    {blockItems.map((block, index) => {
      // Calculate width based on columns (e.g., 2 columns = 50% width)
      const widthPercentage = 100 / (parseInt(columns) || 1);
      
      return (
        <div 
          key={index} 
          className="mb-5"
          style={{
            width: `calc(${widthPercentage}% - 20px)`, // Subtract gap width
            minWidth: '100px', // Minimum width for each block
            height:"100px"
          }}
        >
          <div
            className="border px-4 py-1 rounded-lg cursor-pointer hover:bg-gray-50 h-full"
            onClick={() => openBlockDrawer(index)}
          >
            <h3 className="font-medium mb-1">Block {index + 1}</h3>

            {block.BlockType === "text" && (
              <div>
                <p className="text-(--list-item-gray)">Text Block</p>
                {block.BlockText && (
                  <p className=" truncate">{block.BlockText}</p>
                )}
              </div>
            )}

            {block.BlockType === "image" && block.BlockImage && (
              <div className="relative">
                <img
                  src={block.BlockImage.Preview}
                  alt="block preview"
                  className="h-[60px] w-[90px] object-cover rounded"
                />
                {block.BlockImageText && (
                  <p className="mt-2 text-sm text-(--list-item-gray)">{block.BlockImageText}</p>
                )}
              </div>
            )}

            {block.BlockType === "video" && block.BlockVideoURL && (
              <div>
                <p className="text-(--list-item-gray) truncate">Video Block</p>
                <p className="mt-1 text-sm truncate">{block.BlockVideoURL}</p>
              </div>
            )}

            {(!block.BlockType ||
              (block.BlockType === "image" && !block.BlockImage) ||
              (block.BlockType === "video" && !block.BlockVideoURL)) && (
                <p className="text-(--list-item-gray) italic">Click to configure block</p>
              )}
          </div>
        </div>
      );
    })}
  </div>
)}

          </PageSection>

          <PageSection title="Layout Settings">
            <div className="grid lg:grid-cols-4 sm:grid-cols-1 gap-5 mt-5">
              <Colorpickerwithsearchbar
                label="Section background color"
                showpickcolorbton="true"
                placeholder="#000000"
                value={sectionBackgroundColor}
                onChange={(color) => setSectionBackgroundColor(color)}
              />
             

              <Input
                label="Section margin"
                endtext="set margin"
                placeholder={formatValueForDisplay(margin)}
                value={formatValueForDisplay(margin)}
                handleEndtextOnclick={() => openMarginDrawer("section margin")}
              />

              <Input
                label="Section padding"
                endtext="set padding"
                placeholder={formatValueForDisplay(padding)}
                value={formatValueForDisplay(padding)}
                handleEndtextOnclick={() => openMarginDrawer("section padding")}
              />

              <CustomSwitch
                formlabel="Hide section title"
                checked={hideSectionTitle}
                onChange={(checked) => setHideSectionTitle(checked)}
              />

              {!hideSectionTitle && (
                <>
                  <Select
                    label="Section title alignment"
                    placeholder="Section title alignment"
                    options={[
                      { label: "Left", value: "left" },
                      { label: "Right", value: "right" },
                      { label: "Center", value: "center" }
                    ]}
                    value={sectionTitleAlignment}
                    onChange={(e) => setSectionTitleAlignment(e.target.value)}
                  />

                  <Input
                    label="Section title font size (px)"
                    type="number"
                    value={sectionTitleFontSize}
                    onChange={(e) => setSectionTitleFontSize(e.target.value)}
                  />

                  <Colorpickerwithsearchbar
                    label="Section title font color"
                    showpickcolorbton="true"
                    placeholder="#000000"
                    value={sectionTitleColor}
                    onChange={(color) => setSectionTitleColor(color)}
                  />

                  <Colorpickerwithsearchbar
                    label="Section title underline color"
                    showpickcolorbton="true"
                    placeholder="#000000"
                    value={sectionTitleUnderLineColor}
                    onChange={(color) => setSectionTitleUnderlineColor(color)}
                  />

                  <Input
                    label="Section title margin"
                    endtext="set margin"
                    placeholder={formatValueForDisplay(sectionTitleMargin)}
                    value={formatValueForDisplay(sectionTitleMargin)}
                    handleEndtextOnclick={() => openMarginDrawer("section title margin")}
                  />

                  <Input
                    label="Section title padding"
                    endtext="set padding"
                    placeholder={formatValueForDisplay(sectionTitlePadding)}
                    value={formatValueForDisplay(sectionTitlePadding)}
                    handleEndtextOnclick={() => openMarginDrawer("section title padding")}
                  />

                  <Input
                    label="Css Name"
                    type="text"
                    value={sectionTitleCssName}
                    onChange={(e) => setSectionTitleCssName(e.target.value)}
                  />
                </>
              )}
            </div>
          </PageSection>
        </div>}

      {showDrawer && (
        <MarginDrawer
          setDrawer={setShowDrawer}
          title={drawerTitle}
          initialValues={
            drawerType === "section margin" ? margin :
              drawerType === "section padding" ? padding :
                drawerType === "section title margin" ? sectionTitleMargin :
                  sectionTitlePadding
          }
          onSave={handleDrawerSave}
        />
      )}

      {showBlockDrawer && (
        <BlockDrawer
          setDrawer={setShowBlockDrawer}
          title={`Configure Block ${currentBlockIndex + 1}`}
          initialValues={blockItems[currentBlockIndex]}
          onSave={handleBlockSave}
        />
      )}
    </CreatePage>
  );
};

export default NewHomeSection;